import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import Image from '@redbubble/design-system/src/Image';
import Stack from '@redbubble/design-system/src/Stack';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { Work } from 'types/shop-bff/types';
import {
  MatureContentCover,
  MatureContentCoverStyle,
} from '../../../../components/MatureContentCover';
import styles from './ArtworkInfo.module.scss';

interface ArtworkInfoProps {
  work: Work;
}

const messages = defineMessages({
  imageAltText: {
    defaultMessage: 'Artwork thumbnail, {workTitle} by {artistName}',
  },
});

export const ArtworkInfo: React.FC<ArtworkInfoProps> = ({ work }) => {
  const intl = useIntl();

  if (!work) return null;

  const portfolioImageUrl = work.portfolioPreview && work.portfolioPreview.url;

  return (
    <Box className={styles.container}>
      <Box className={styles.imageContainer}>
        <MatureContentCover
          aspectRatioHeight={1}
          styleType={MatureContentCoverStyle.EyesOnly}
          matureContent={work.matureContent}
        >
          <Image
            src={portfolioImageUrl}
            size={constants.SMALL}
            ratio={constants.RATIO_SQUARE}
            alt={intl.formatMessage(messages.imageAltText, {
              workTitle: work.title,
              artistName: work.artistShopDisplayName,
            })}
            fluid
            roundedCorners
          />
        </MatureContentCover>
      </Box>
      <Box className={styles.titleContainer}>
        <Stack>
          <Text type="display3">{work.title}</Text>
          <Text type="body" muted>
            {work.description}
          </Text>
        </Stack>
      </Box>
    </Box>
  );
};
